module.exports = __webpack_public_path__ + "static/img/9.e4267da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/sp/9.png
// module id = gzgw
// module chunks = 0